module.exports = __webpack_public_path__ + "assets/pdfs/RBResume.1144c1de.pdf";